// extracted by mini-css-extract-plugin
export default {"freeTrialBadge":"FreeTrialBadge_freeTrialBadge__UGla5","success":"FreeTrialBadge_success__T42Ib","warning":"FreeTrialBadge_warning__eYqTR","error":"FreeTrialBadge_error__SsPMU"};